import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { User } from '../../../../../../../../models/user';
import { CallbackResult, CallbackResultStatus, getStaffNameDisplay } from '../../../../../../../../utils';
import { UserService } from '../../../../../../../../services/user/user.service';
import {
  LightspeedStaffUser,
  OrganizationConfigService,
} from '../../../../../../../../services/organization-config/organization-config.service';


@Component({
  selector: 'app-set-user-lightspeed-user-modal',
  templateUrl: './set-user-lightspeed-user-modal.component.html',
  styleUrls: ['./set-user-lightspeed-user-modal.component.css']
})
export class SetUserLightspeedUserModalComponent implements OnInit {
  @Input() user: User;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public lightspeedUserList: LightspeedStaffUser[];
  public selectedLightspeedUser: LightspeedStaffUser = null;

  public loadingLightspeedUsers = true;
  public loadingSave = false;

  public errorMessage = '';
  public serverError: number = null;

  public readonly getStaffNameDisplay = getStaffNameDisplay;

  constructor(
    public activeModal: NgbActiveModal,
    private orgConfigService: OrganizationConfigService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.loadLightspeedUsers();
  }

  public handleSubmit() {
    if (this.loadingLightspeedUsers || this.loadingSave) { return; }

    this.loadingSave = true;
    this.errorMessage = '';

    const userCopy: User = {...this.user};
    if (this.selectedLightspeedUser === null) {
      userCopy.lightspeed_user_id = '';
      userCopy.lightspeed_user_username = '';
      userCopy.lightspeed_user_display_name = '';
    } else {
      userCopy.lightspeed_user_id = this.selectedLightspeedUser.user_id;
      userCopy.lightspeed_user_username = this.selectedLightspeedUser.username;
      userCopy.lightspeed_user_display_name = this.selectedLightspeedUser.display_name;
    }

    this.userService
      .updateUserLightspeedInfo(userCopy)
      .then(() => {
        this.savedCallback({
          text: 'Lightspeed user updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to take this action.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSave = false; });
  }

  private loadLightspeedUsers() {
    this.loadingLightspeedUsers = true;

    this.orgConfigService
      .getLightspeedStaffUsers()
      .then(response => {
        this.lightspeedUserList = response;
        if (this.user.lightspeed_user_id !== '') {
          for (const lightspeedUser of this.lightspeedUserList) {
            if (lightspeedUser.user_id === this.user.lightspeed_user_id) {
              this.selectedLightspeedUser = lightspeedUser;
            }
          }
        }
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to take this action.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingLightspeedUsers = false; });
  }
}
